import { RiApps2Fill } from "react-icons/ri";
import { BsBoxFill } from "react-icons/bs";
import { GoHeartFill, GoChevronDown } from "react-icons/go";
import { RiQuestionnaireFill } from "react-icons/ri";
import { IoLogOut } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect, useRef } from "react";
import { clearToken } from "../../../../redux/slices/loginSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import SidebarSkeleton from "./SidebarSkeleton";

const SIDEBAR_ITEMS = [
    { key: "dashboard", label: "داشبورد", icon: <RiApps2Fill size={20} /> },
    { key: "myloads", label: "آگهی های من", icon: <BsBoxFill size={20} /> },
    { key: "favorites", label: "علاقه مندی", icon: <GoHeartFill size={20} /> },
    { key: "support", label: "پشتیبانی", icon: <RiQuestionnaireFill size={20} /> },
];

export default function Sidebar({ active, setActive }) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);
    const dispatch=useDispatch()
    const navigate=useNavigate()

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) setOpen(false);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const handleSelect = (key) => {
        setActive(key);
        setOpen(false);
    };


    const activeItem = SIDEBAR_ITEMS.find((i) => i.key === active) || SIDEBAR_ITEMS[0];

    if (!activeItem) return <SidebarSkeleton />;

    return (
        <>

            <div className="lg:hidden px-4 mt-6">
                <div className="relative" ref={containerRef}>
                    <button
                        onClick={() => setOpen((s) => !s)}
                        aria-expanded={open}
                        className="w-full flex items-center justify-between gap-3 rounded-2xl bg-blue-50 px-4 py-3 shadow font-bold text-special"
                    >
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 flex items-center justify-center rounded-md bg-white/80">
                                {activeItem.icon}
                            </div>
                            <span className="text-sm">{activeItem.label}</span>
                        </div>

                        <motion.span
                            animate={{ rotate: open ? 180 : 0 }}
                            transition={{ type: "spring", stiffness: 400, damping: 30 }}
                            className="flex items-center"
                        >
                            <GoChevronDown size={20} />
                        </motion.span>
                    </button>


                    <AnimatePresence initial={false}>
                        {open && (
                            <motion.div
                                initial={{ opacity: 0, y: -6 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -6 }}
                                transition={{ duration: 0.18 }}
                                className="mt-3 rounded-2xl bg-white/80 shadow-lg overflow-hidden"
                            >
                                <div className="flex flex-col">
                                    {SIDEBAR_ITEMS.map((item) => {
                                        const isActive = item.key === active;
                                        return (
                                            <motion.button
                                                key={item.key}
                                                onClick={() => handleSelect(item.key)}
                                                initial={{ opacity: 0, y: -4 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ delay: 0.02 }}
                                                className={`w-full text-right flex items-center justify-between gap-2 px-4 py-3 border-b last:border-b-0
                                                    ${isActive ? "bg-special text-white font-bold" : "text-special hover:bg-blue-50"}`}
                                            >
                                                <div className="flex items-center gap-3">
                                                    <div className="w-8 h-8 flex items-center justify-center rounded-md bg-transparent">
                                                        {item.icon}
                                                    </div>
                                                    <span className="text-sm">{item.label}</span>
                                                </div>

                                                {/* نمایش یک تیک برای آیتم فعال در منوی باز */}
                                                {isActive && (
                                                    <span className="text-xs px-2 py-1 rounded bg-green-100 text-green-700">انتخاب‌شده</span>
                                                )}
                                            </motion.button>
                                        );
                                    })}

                                    <div className="px-4 py-3">
                                        <button
                                            className="w-full flex items-center gap-2 text-special hover:bg-blue-100 rounded-lg px-4 py-2 font-bold"
                                            onClick={() => {
                                                // اگر خواستی اینجا لاگ‌اوت واقعی بزنی، تابع رو صدا بزن
                                                setOpen(false);
                                            }}
                                        >
                                            <IoLogOut size={20} />
                                            خروج از حساب
                                        </button>
                                    </div>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </div>


            <aside className="hidden lg:flex flex-col gap-4 shadow w-full lg:w-72 my-10 bg-blue-50 rounded-3xl p-6 lg:h-[calc(100vh-10rem)]">
                <div className="flex flex-col gap-2">
                    {SIDEBAR_ITEMS.map((item) => (
                        <button
                            key={item.key}
                            className={`flex items-center gap-2 rounded-lg px-4 py-2 font-bold transition 
                                ${active === item.key ? "bg-special text-white" : "text-special hover:bg-blue-100"}`}
                            onClick={() => setActive(item.key)}
                        >
                            {item.icon}
                            {item.label}
                        </button>
                    ))}
                </div>
                <div className="mt-auto">
                    <button  onClick={()=>{dispatch(clearToken()) ;navigate("/login")}} className="flex items-center gap-2 text-special hover:bg-blue-100 rounded-lg px-4 py-2 font-bold w-full">
                        <IoLogOut size={24} />
                        خروج از حساب
                    </button>
                </div>
            </aside>
        </>
    );
}
